















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {EventItem} from '@/store/models';
import user from '@/store/modules/user';

@Component
export default class StartCompanyItem extends Vue {
    @Prop() event: EventItem | undefined;

    async gotoItem() {
        if (!this.event) {
            return;
        }
        if (user.company.overview && user.company.overview.OrgNr !== this.event.OrgNr) {
            await user.clearCompany();
        }
        const OrgNr: string = this.event.OrgNr;
        this.$router.push({ name: 'overview', params: { OrgNr } });
    }
}
